export const handelGetParamsFromUrl = (query, location) => {
  console.log(location, 'location');
  const CarBrandId = query?.get('CarBrandId');
  const CarModelId = query?.get('CarModelId');
  const GearTypeId = query?.get('GearTypeId');
  const CarFuelTypeId = query?.get('CarFuelTypeId');
  const CarShapeId = query?.get('CarShapeId');
  const FromPrice = query?.get('FromPrice');
  const ToPrice = query?.get('ToPrice');
  const ProductionYearFrom = query?.get('ProductionYearFrom');
  const ProductionYearTo = query?.get('ProductionYearTo');
  const body = {
    CarBrandId,
    CarModelId,
    FromPrice,
    ToPrice,
    GearTypeId,
    CarFuelTypeId,
    ProductionYearFrom,
    ProductionYearTo,
    CarShapeId,
  };
  return body;
};

export const generateYearsArray = (
  minYear,
  maxYear,
  inLabelsAndValues = false
) => {
  const yearsArray = [];
  for (let year = minYear; year <= maxYear; year++) {
    if (inLabelsAndValues) yearsArray.push({ label: year, value: year });
    else yearsArray.push(year);
  }
  return yearsArray;
};
